import React, { useEffect, useState } from 'react';
import Link from 'next/link';
import { useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import moment from 'moment';
import { getUserName } from '../../services/common-query';
import { CompareSharp } from '@material-ui/icons';
import { bucketlink1 } from '../../config/fire-conf';
import {
  collection,
  getDocs,
  setDoc,
  doc,
  query,
  where,
} from '@firebase/firestore/lite';

import { firebaseFireStore } from '../../config/firebaseFirestore';

export default function DetailsTab(props) {
  const userDataRedux = useSelector((state) => state.authReducer.userData);
  const router = useRouter();
  const [issuerName, setissuerName] = useState('');
  const [isMinter, setIsMinter] = useState(false);

  const { ele } = props;

  useEffect(() => {
    if (props.nftData && props.nftData.issuerID) {
      getNameFromId();
    }
  }, [props.nftData]);

  const getNameFromId = async () => {
    let lname = await getUserName(props.nftData.issuerID);

    if (lname) {
      setissuerName(lname);
    } else {
      setissuerName('unknown');
    }
  };
  console.log(props.nftData);

  const getMinter = async () => {
    // console.log(ele.userId ,  "==============>>>")
    let dataQuery = query(
      collection(firebaseFireStore, 'musicartMinters'),
      // where('minterId', '==', ele.userId),
    );
    let dataRef = await getDocs(dataQuery);
    console.log(dataRef.docs.forEach((data) => {}));
    if (!dataRef.empty) {
      setIsMinter(true);
      return;
    } else {
      setIsMinter(false);
    }
  };
  useEffect(() => {
    getMinter();
  }, []);

  console.log('props.nftData ', props.nftData);

  return (
    <div className="nft__tab_pane nft__tab__pane--scroll" role="tabpanel">
      <div className="nft__tab_content">
        <ul className="asset__authors asset__authors--tab">
          <li>
            <span>Minter</span>
            {/* className={`asset__author ${isMinter?"asset__author--verified":""}`} */}
            <div
              className={`asset__author ${
                isMinter ? 'asset__author--verified' : ''
              }`}
            >
              <img
                style={{ minWidth: 44, minHeight: 44 }}
                src={
                  props?.nftData?.issuerID &&
                  bucketlink1 +
                    'profile_images%2F' +
                    props.nftData.issuerID +
                    '_250x250?alt=media'
                }
                alt="minter image"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = '/img/avatars/avatar.jpg';
                }}
              />
              {props.nftData && issuerName && (
                <Link
                  prefetch={false}
                  href={'/collector/' + props.nftData.issuerID}
                >
                  <a>@{issuerName}</a>
                </Link>
              )}
            </div>
          </li>
          {props.nftData && props.nftData.creationDate && (
            <li>
              <span>Creation Date</span>
              <p>
                {moment(Number(props.nftData.creationDate)).format(
                  'DD MMM YYYY',
                )}
              </p>
            </li>
          )}

          <li>
            <span>Description</span>
            <p>
              {props.nftData && props.nftData.tokenDescription
                ? props.nftData.tokenDescription
                : '-'}
            </p>
          </li>

          {props.nftData && props.nftData.royalty && (
            <li>
              <span style={{ marginBottom: 0, display: 'flex' }}>
                Royalty:&nbsp;<p>{props.nftData.royalty}%</p>
              </span>
            </li>
          )}

          {props.nftData && props.nftData.category && (
            <li>
              <span style={{ marginBottom: 0, display: 'flex' }}>
                Category:&nbsp;<p>{props.nftData.category}</p>
              </span>
            </li>
          )}

          {props.nftData && (
            <li>
              <span style={{ marginBottom: 0, display: 'flex' }}>
                Edition Type:&nbsp;
                <p>
                  {props?.nftData?.editionType
                    ? props.nftData.editionType
                    : 'Limited Edition'}
                </p>
              </span>
            </li>
          )}

          {props.nftData && props.nftData.openEdition && (
            <li>
              <span style={{ marginBottom: 0, display: 'flex' }}>
                Edition:&nbsp;<p>{props.nftData.openEdition}</p>
              </span>
            </li>
          )}

          {props.nftData && props.nftData.contractTxid && (
            <li>
              <span>Contract Transaction ID</span>
              <p>
                <a
                  href={
                    'https://whatsonchain.com/tx/' + props.nftData.contractTxid
                  }
                  target="_blank"
                >
                  <div className="link">
                    {props.nftData.contractTxid.slice(0, 25)}...
                  </div>
                </a>
              </p>
            </li>
          )}

          {props.nftData && props.nftData.issueTxid && (
            <li>
              <span>Issuance Transaction ID</span>
              <p>
                <a
                  href={
                    'https://whatsonchain.com/tx/' + props.nftData.issueTxid
                  }
                  target="_blank"
                >
                  <div className="link">
                    {props.nftData.issueTxid.slice(0, 25)}...
                  </div>
                </a>
              </p>
            </li>
          )}
        </ul>
      </div>
    </div>
  );
}
